import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { completeSecondFactorConfiguration } from 'actions/seguridad';
import { redirectUriPostSecondFactorSelector } from 'store/selectors';
import { AUTOGESTION_IDP } from 'constants/RouterConstants';
import {
  MFA_TOTP_VERIFIED_TITLE,
  MFA_TOTP_VERIFIED_DESC,
} from 'constants/commonConstants';
import CardSuccess from 'components/CardSuccess';
import ButtonSolid from 'components/ButtonSolid';

const Enforce2FAExitosoAplicativo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectUriPostSecondFactor = useSelector(
    redirectUriPostSecondFactorSelector,
  );
  const handleClick = () => {
    dispatch(completeSecondFactorConfiguration());
    if (redirectUriPostSecondFactor)
      window.location.href = redirectUriPostSecondFactor;
    else history.push(AUTOGESTION_IDP);
  };
  return (
    <CardSuccess
      title={MFA_TOTP_VERIFIED_TITLE}
      description={MFA_TOTP_VERIFIED_DESC}
      extra2={
        <ButtonSolid
          text="Entendido"
          handleClick={handleClick}
          style={{ marginTop: '20px' }}
        />
      }
    />
  );
};

export default Enforce2FAExitosoAplicativo;
